module.exports = __webpack_public_path__ + "img/thumbnail-header-0.a68ba7a.jpeg";